import * as React from 'react';
import { LinkColumnWrapper, LinkHeader, LinkItem, LinkItemAnchor } from './LinkColumnStyles';
import { LinkItemType } from '../../types';
import { LinkIndividualSchemaType } from '../../types/LinkSchema';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { actionTaken } from '../../../../ReduxApp/app/user-sessions/duck/operations';
import { AvailableActions } from '../../../../ReduxApp/app/user-sessions/duck/actionTypes';

export type Props = {
	linkSchema: LinkIndividualSchemaType;
};

export const LinkColumnLayout = (props: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const render = () => {
		const returnValue = (
			<LinkColumnWrapper>
				<LinkHeader>{props.linkSchema.title}</LinkHeader>
				{generateLinkItems(props.linkSchema.linkItems, navigate, location, dispatch)}
			</LinkColumnWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

const generateLinkItems = (linkItems: Array<LinkItemType>, navigate: (href: string) => void, location: any, dispatch: any) => {
	const returnValue = linkItems.map((linkItem, index: number) => {
		const onClick = () => {
			dispatch(actionTaken(AvailableActions.ITEM_PRESSED, 'Footer -> ' + linkItem['name'], location.pathname));
			navigate(linkItem['href']);
		};
		const linkProps: { key: string; onClick?: () => void; href?: string } = {
			key: 'linkitemline' + index,
			onClick: onClick,
		};
		let innerReturnValue = <LinkItem {...linkProps}>{linkItem['name']}</LinkItem>;
		if (linkItem['href'].indexOf('mailto:') !== -1) {
			delete linkProps.onClick;
			linkProps.href = linkItem['href'];
			innerReturnValue = <LinkItemAnchor {...linkProps}>{linkItem['name']}</LinkItemAnchor>;
		}

		return innerReturnValue;
	});
	return returnValue;
};
